/** Generated from src/an26-tokens.scss — do not edit directly. */
@charset "UTF-8";
/**
 * AN26 chart design tokens — colors, typography, spacing.
 * Host pages should load the actual fonts; the SDK keeps only font-family tokens.
 */
:root {--an26-series-1: #E3DABB;
  --nten-series-1: #E3DABB;
  --an26-series-2: #93886D;
  --nten-series-2: #93886D;
  --an26-series-3: #434432;
  --nten-series-3: #434432;
  --an26-series-1-faded: #F9F8F1;
  --nten-series-1-faded: #F9F8F1;
  --an26-series-2-faded: #F4F3F0;
  --nten-series-2-faded: #F4F3F0;
  --an26-series-3-faded: #ECECEA;
  --nten-series-3-faded: #ECECEA;
  /* Surfaces */
  --an26-bg: #ffffff;
  --nten-bg: #ffffff;
  --an26-bg-holdings: #F8F6F0;
  --nten-bg-holdings: #F8F6F0;
  --an26-border: #e5e5e5;
  --nten-border: #e5e5e5;
  --an26-border-strong: #000000;
  --nten-border-strong: #000000;
  --an26-grid: #e5e5e5;
  --nten-grid: #e5e5e5;
  /* Text */
  --an26-text-primary: #1a1a1a;
  --nten-text-primary: #1a1a1a;
  --an26-text-secondary: #666666;
  --nten-text-secondary: #666666;
  --an26-text-bold: #000000;
  --nten-text-bold: #000000;
  /* Toggle */
  --an26-toggle-active-bg: #ECE5CF;
  --nten-toggle-active-bg: #ECE5CF;
  --an26-toggle-border: #333333;
  --nten-toggle-border: #333333;
  /* Typography */
  --an26-font-heading: "Ivory LL", Georgia, "Times New Roman", serif;
  --nten-font-heading: "Ivory LL", Georgia, "Times New Roman", serif;
  --an26-font-body: "Sohne", system-ui, -apple-system, sans-serif;
  --nten-font-body: "Sohne", system-ui, -apple-system, sans-serif;
  --an26-font-mono: "Sohne Mono", ui-monospace, "Cascadia Code", monospace;
  --nten-font-mono: "Sohne Mono", ui-monospace, "Cascadia Code", monospace;
  --an26-fs-title: clamp(1.5rem, 2.2vw, 1.85rem);
  --nten-fs-title: clamp(1.5rem, 2.2vw, 1.85rem);
  --an26-fs-title-sm: 1.15rem;
  --nten-fs-title-sm: 1.15rem;
  --an26-fs-subtitle: 0.8125rem;
  --nten-fs-subtitle: 0.8125rem;
  --an26-fs-body: 0.8125rem;
  --nten-fs-body: 0.8125rem;
  --an26-fs-mono: 0.75rem;
  --nten-fs-mono: 0.75rem;
  --an26-fs-table-head: 0.8125rem;
  --nten-fs-table-head: 0.8125rem;
  /* Spacing */
  --an26-space-xs: 4px;
  --nten-space-xs: 4px;
  --an26-space-sm: 8px;
  --nten-space-sm: 8px;
  --an26-space-md: 16px;
  --nten-space-md: 16px;
  --an26-space-lg: 24px;
  --nten-space-lg: 24px;
  --an26-space-xl: 32px;
  --nten-space-xl: 32px;
  --an26-space-2xl: 48px;
  --nten-space-2xl: 48px;
  /* Tooltip */
  --an26-tooltip-bg: #ffffff;
  --nten-tooltip-bg: #ffffff;
  --an26-tooltip-border: #333333;
  --nten-tooltip-border: #333333;
  --an26-tooltip-radius: 2px;
  --nten-tooltip-radius: 2px;
  --an26-tooltip-shadow: none;
  --nten-tooltip-shadow: none;
}